import React from 'react';
import { Box } from '@beeline.com/bp-design-system';

interface ModalFooterProps {
  children?: React.ReactNode;
}

export const ModalFooter = ({ children }: ModalFooterProps) => {
  return (
    <Box pt={5} className="modal-footer">
      {children}
    </Box>
  );
};
